import { getDateFormatForFrontend, getTimeFormatForFrontend } from '../../../app/Helpers/DateTimeHelper';
import { BASIC_SETTINGS, LANGUAGE } from "../../../app/Config/ApiUrl";
import { axiosGet, urlGenerator } from "../../../app/Helpers/AxiosHelper";
import { settings } from 'accounting';
import { colors } from "./customize";

export default {

	state: {
		dateFormat: window.settings?.date_format ? getDateFormatForFrontend(window.settings.date_format) : "DD-MM-YYYY",
		timeFormat: window.settings?.time_format ? getTimeFormatForFrontend(window.settings.time_format) : 12,
		appSettings: window.settings ? window.settings : {},
		selectedLanguage: {},
		languages: [],
		customizer: {
			secondarySkinColor: null,
			primarySkinColor: null,
			primaryColor: null,
			textColor: null,
			borderColor: null,
			chatImg: null,
			navColor: null,
			navTextColor: null,
		},
	},

	getters: {
		appSettings: state => state.appSettings,
		accountcustomizer: state => state.customizer,
	},

	mutations: {

		SET_SETTINGS(state, setting) {
			state.appSettings = setting;

			if (setting.whitelabel_domain) {
				state.appSettings.whitelabel_domain = setting.whitelabel_domain.split(".")[0]
			}
			state.appSettings.logo = setting?.company_logo;
			state.appSettings.icon = setting?.company_icon;

			state.appSettings.company_icon = setting?.company_icon;
			state.appSettings.company_logo = setting?.company_logo;
			state.appSettings.company_banner = setting?.company_banner;
			if (window.settings?.date_format)
				state.dateFormat = getDateFormatForFrontend(setting?.date_format);
			if (window.settings?.time_format)
				state.timeFormat = getTimeFormatForFrontend(setting?.time_format);
		},


		SET_LANGUAGES(state, data) {
			state.languages = data.map((lang) => {
				return {
					...lang,
					id: lang.key,
					value: lang.title
				}
			});
		},

		SET_SELECTED_LANGUAGE(state, rootState) {
			const { locale, translations } = rootState.i18n;
			state.selectedLanguage = translations[locale];
		},

		setCustomizationOptions(state, data) {

			this.commit('updateSkinPrimary', data.primarySkinColor);
			this.commit('updateSkinSecondary', data.secondarySkinColor);
			this.commit('updateTextColor', data.textColor);
			this.commit('updateNavColor', data.navColor);
			this.commit('updateNavTextColor', data.navTextColor);
			this.commit('updatePrimaryColor', data.primary);
			this.commit('updateBorderColor', data.borderColor);

		},

		updateCustomization(state, data) {
			state.customizer = data;
			window.localStorage.setItem('customizationOptions', JSON.stringify(data));
		},

		updateSkinPrimary(state, val) {

			if (val) {
				document.documentElement.style.setProperty("--app-background-color", val);
				document.documentElement.style.setProperty("--primarySkin", val);
			}

		},

		updateSkinSecondary(state, val) {
			//state.customizer.secondarySkinColor = val;

			if (val) {
				document.documentElement.style.setProperty("--default-card-bg", val);
				document.documentElement.style.setProperty("--vertical-tab-header-bg", val);
				document.documentElement.style.setProperty("--secondarySkin", val);
				document.documentElement.style.setProperty("--calendar-bg", val);
				document.documentElement.style.setProperty("--btn-filter-bg", val);

				document.documentElement.style.setProperty("--modal-header-footer-bg", val);
				document.documentElement.style.setProperty("--modal-body-bg", val);
			}

		},

		updateTextColor(state, val) {

			if (val) {
				document.documentElement.style.setProperty("--default-font-color", val);
			} else {
				// document.documentElement.style.setProperty("--textColor", '#6c757d');
			}

		},


		updateNavColor(state, val) {


			if (val) {
				document.documentElement.style.setProperty("--navColor", val);
				//document.documentElement.style.setProperty("--primary", val);
			} else {
				//  document.documentElement.style.setProperty("--navColor", '#ffffff');
			}

		},

		updateNavTextColor(state, val) {

			if (val) {
				document.documentElement.style.setProperty("--navTextColor", val);
			} else {
				// document.documentElement.style.setProperty("--navTextColor", '#6c757d'); 
			}

		},


		updateBorderColor(state, val) {

			if (val) {
				document.documentElement.style.setProperty("--borderColor", val);
				document.documentElement.style.setProperty("--btn-filter-bg", val);
				document.documentElement.style.setProperty("--default-border-color", val);


			} else {
				//document.documentElement.style.setProperty("--borderColor", '#ebe9f1');
			}

		},



		updatePrimaryColor(state, val) {
			if (val) {
				document.documentElement.style.setProperty("--primary", val);
			}
		},



	},

	actions: {
		getSettings({ commit }) {
			axiosGet(BASIC_SETTINGS).then(({ data }) => {
				commit('SET_SETTINGS', data);
			});
		},

		getLanguages({ commit, state }) {
			if (!state.languages.length) {
				axiosGet(LANGUAGE).then(({ data }) => {
					commit('SET_LANGUAGES', data)
				});
			}
		},

		setSelectedLanguage({ commit, rootState }) {
			commit('SET_SELECTED_LANGUAGE', rootState)
		},


		async getConfig({ commit }) {
			axios.get('/app/get-customisation').then(({ data }) => {

				commit("updateCustomization", data);
				commit("setCustomizationOptions", data);


			}, (err) => {
				console.log(err)
			});
		},

		async changeConfig({ commit }, data) {

			const input = { ...data };
			const { skinConfiguration } = input;

			if (skinConfiguration) {
				const {
					primarySkinColor,
					secondarySkinColor,
					primaryColor,
					textColor,
					borderColor,
					navColor,
					navTextColor,
				} = skinConfiguration;

				commit("updateSkinPrimary", primarySkinColor);
				commit("updateSkinSecondary", secondarySkinColor);
				commit("updatePrimaryColor", primaryColor);

				commit("updateTextColor", textColor);
				commit("updateBorderColor", borderColor);
				commit("updateNavColor", navColor);
				commit("updateNavTextColor", navTextColor);


			} else {
				commit("updateSkinPrimary", colors.primarySkinColor);
				commit("updateSkinSecondary", colors.secondarySkin);
				commit("updatePrimaryColor", colors.primary);
				commit("updateTextColor", colors.textColor);
				commit("updateBorderColor", colors.borderColor);
				commit("updateNavColor", colors.navColor);
				commit("updateNavTextColor", colors.navTextColor);
			}

			axios.post('/update-customisation', data.skinConfiguration).then(({ data }) => {

				commit("updateCustomization", data);
				window.localStorage.setItem('customizationOptions', JSON.stringify(data));

			}, (err) => {
				console.log(err)
				//log thi error
			});


			// try {
			//   const ag = await API.graphql(
			// 	graphqlOperation(updateAgency, {
			// 	  input,
			// 	})
			//   );
			//   if (ag.data.updateAgency) {
			// 	dispatch("SET_SKIN_CONFIG", ag.data.updateAgency.skinConfiguration, {
			// 	  root: true,
			// 	});
			//   }
			// } catch (err) {
			//   //
			// }


		},

		updateConfig({ commit }, config) {
			const {
				primarySkinColor,
				secondaryColor,
				primaryColor,
				chatBgColor,
				chatBg,
				textColor,
				borderColor,
				navColor,
				navTextColor,
			} = config;

			commit("updateSkinPrimary", primarySkinColor || colors.primarySkinColor);
			commit("updateSkinSecondary", secondaryColor || colors.secondarySkin);
			commit("updatePrimaryColor", primaryColor || colors.primary);
			commit("updateChatBackground", chatBgColor || colors.chatBgColor);
			commit("updateTextColor", textColor || colors.textColor);
			commit("updateBorderColor", borderColor || colors.borderColor);
			commit("updateNavColor", navColor || colors.navColor);
			commit("updateNavTextColor", navTextColor || colors.navTextColor);

		},


	}
}
